import './animation-toggle.scss';

class AnimationToggle {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-animation-toggle'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$animation = undefined;

        // Options
        this.isPaused = this.$root.getAttribute('aria-pressed') === 'true'; // Determine if the animation is initially paused
        this.animationType = this.$root.getAttribute(this.settings.initAttr); // Get the type of animation
    }

    initialize () {
        if (this.animationType !== null) {
            this.getAnimation(); // Get the animation element

            if (this.$animation) {
                this.setEvents(); // Set up event listeners
            }
        }
    }

    getAnimation () {
        if (this.animationType === 'gif') {
            this.$animation = this.$root.parentNode.querySelector('img'); // Get the image element for GIFs
        }

        // ... expand for videos, etc. here
    }

    async createStillFrame (img) {
        const canvas = document.createElement('canvas'); // Create a canvas element
        const context = canvas.getContext('2d'); // Get the canvas context
        canvas.width = img.width; // Set the canvas width to the image width
        canvas.height = img.height; // Set the canvas height to the image height

        context.drawImage(img, 0, 0, img.width, img.height); // Draw the current image on the canvas
        return canvas.toDataURL('image/png'); // Return the still frame as a data URL
    }

    async toggleAnimation () {
        if (this.animationType === 'gif') {
            if (this.isPaused) {
                this.$animation.src = this.$animation.dataset.src; // Resume the GIF
                this.$root.setAttribute('aria-pressed', 'false'); // Update aria attributes
                this.$root.setAttribute('aria-label', 'Pause Animation');
            } else {
                this.$animation.dataset.src = this.$animation.src; // Save the current src
                const stillFrame = await this.createStillFrame(this.$animation); // Create a still frame from the GIF
                this.$animation.src = stillFrame; // Set src to the still frame
                this.$root.setAttribute('aria-pressed', 'true'); // Update aria attributes
                this.$root.setAttribute('aria-label', 'Play Animation');
            }
        }
    }

    setEvents () {
        this.$root.addEventListener('click', () => {
            this.toggleAnimation(); // Toggle the animation state
            this.isPaused = !this.isPaused; // Update the paused state
        });
    }
}

export { AnimationToggle };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$root = $context.querySelectorAll('[data-animation-toggle]');
        for (let i = 0; i < $$root.length; i++) {
            const $root = $$root[i];

            const $rootAPI = new AnimationToggle($root);
            $rootAPI.initialize();
        }
    }
});
